import MaintenancePage from "../MaintenancePage";
import Resource from "features/maintenance/resources/registerUserResource";

export default function RegisterUsers() {
    return <MaintenancePage resource={Resource} />;
}
